import { Link } from 'react-router-dom';
import { IoCartOutline } from 'react-icons/io5';
import { BsCartPlus, BsCash } from 'react-icons/bs';
import { PiClipboardText } from 'react-icons/pi';
import { MdPointOfSale } from 'react-icons/md';
import { FiDollarSign } from 'react-icons/fi';
import { GoGear } from 'react-icons/go';
import { useConfig } from '../../context/ConfigContext';

const isFeatureActive = (feature) =>
    feature && (feature.status === true || feature.status === 1);

const HomeShortcuts = () => {
    const { features } = useConfig();

    const shortcuts = [
        {
            path: '/pedidosCaja',
            label: 'Crear pedidos línea caja',
            Icon: MdPointOfSale,
            visible: isFeatureActive(features.find((f) => f.name === 'PEDIDOS CAJA')),
        },
        { path: '/pedidoMostrador', label: 'Crear pedido', Icon: BsCartPlus, visible: true },
        { path: '/orders', label: 'Ver pedidos', Icon: IoCartOutline, visible: true },
        { path: '/misProductos', label: 'Productos', Icon: PiClipboardText, visible: true },
        {
            path: '/movements',
            label: 'Movimientos',
            Icon: BsCash,
            visible: isFeatureActive(features.find((f) => f.name === 'REPORTES')),
        },
        {
            path: '/cash-register',
            label: 'Caja',
            Icon: FiDollarSign,
            visible: isFeatureActive(features.find((f) => f.name === 'REGISTRO CAJA')),
        },
        { path: '/config/carta', label: 'Configuración', Icon: GoGear, visible: true },
    ].filter((item) => item.visible);

    if (shortcuts.length === 0) {
        return null;
    }

    return (
        <div className="home-shortcuts-section">
            <h2 className="home-section-title">Accesos rápidos</h2>
            <div className="home-shortcuts-grid">
                {shortcuts.map(({ path, label, Icon }) => (
                    <Link key={path} to={path} className="home-shortcut-tile">
                        <span className="home-shortcut-icon" aria-hidden>
                            <Icon size={18} />
                        </span>
                        <span className="home-shortcut-label">{label}</span>
                    </Link>
                ))}
            </div>
        </div>
    );
};

export default HomeShortcuts;
